import { render, staticRenderFns } from "./AlterarSenhaPIN.vue?vue&type=template&id=63451691&scoped=true"
import script from "./AlterarSenhaPIN.vue?vue&type=script&lang=ts"
export * from "./AlterarSenhaPIN.vue?vue&type=script&lang=ts"
import style0 from "./AlterarSenhaPIN.vue?vue&type=style&index=0&id=63451691&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63451691",
  null
  
)

export default component.exports